<div>
    <mat-form-field>
        <mat-label>Select an option</mat-label>
        <mat-select [(value)]="restuarantId" (valueChange)="selectRestuarant($event)" >
            <mat-option [value]="item.id" *ngFor="let item of this.restuarants$ | async">
                {{item.name}}
              </mat-option> 
        </mat-select>
      </mat-form-field>                      
</div>